<template>
  <div class="header-logo__wrapper">
    <a-icon
      :to="fmIntelligenceUrl"
      :icon="$options.consts.ICON.FM_INTELLIGENCE_LOGO_HEADER"
      :no-hover="true"
      :original="true"
      :open-in-new-tab="false"
      width="auto"
      height="auto"
      aria-label="Finance Magnates Intelligence"
      class="header-logo__logo"
    />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'AHeaderLogo',
  components: { AIcon },
  consts: {
    ICON
  },
  data() {
    return {
      fmIntelligenceUrl: this.$helper.generateFmUrl('/intelligence/', this)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-logo__wrapper {
  // do not remove: fix for old safari (12)
  display: flex;
  justify-content: center;
  align-items: center;

  $width: (
    $above-desktop-xl: 195px
  );

  $height: (
    $above-desktop-xl: 32px
  );

  @include setStyleByBreakpoint('width', $width);
  @include setStyleByBreakpoint('height', $height);

  .header-logo__logo {
    // do not remove: fix for old safari (12)
    width: 100%;
  }
}
</style>
